/* eslint-disable camelcase */
import Media from 'components/contentBlocks/Media';
import PropTypes from 'prop-types';
import React from 'react';
import activeSetting from 'libs/wordpress/utils/activeSetting';
import transformFlexibleBackground from 'libs/wordpress/utils/transformFlexibleBackground';
import transformLink from 'libs/wordpress/utils/transformLink';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';

// Pure CMS data transformation before we send it to the "real" block!
const VideoInlineBlock = ({ content, isColumn = false }) => {
    const { background_video: backgroundObj, link, settings } = content;

    let transformedLink;
    if (activeSetting(settings, 'link') && link) {
        transformedLink = transformLink(link);
    }

    // Tranform video data
    const isAboveSm = useAboveBreakpoint('sm');
    const transformedBackground = transformFlexibleBackground(backgroundObj, 'video');
    const mobileBackground = transformedBackground.mobile;
    const desktopBackground = transformedBackground.desktop;

    return (
        <Media
            background={isAboveSm ? desktopBackground : mobileBackground}
            backgroundRatio={isColumn ? 3 / 4 : [3 / 4, null, 16 / 9]}
            backgroundType="video"
            isColumn={isColumn}
            transformedLink={transformedLink}
        />
    );
};

VideoInlineBlock.propTypes = {
    content: PropTypes.shape({
        background_video: PropTypes.exact({
            desktop_background_video: PropTypes.object,
            mobile_background_video: PropTypes.object,
        }),
        link: PropTypes.object,
        settings: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    isColumn: PropTypes.bool,
};

export default VideoInlineBlock;
